import { FormattedInput } from "components/FormInputs/FormattedInput";
import { useField } from "formik";
import { ComponentPropsWithoutRef, useMemo } from "react";
import { cn } from "utils/helpers";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { rfxSubmission } from "newui/features/Rfx/Submission";
import { TextLength } from "newui/features/Rfx/types/component-types";

type TextAreaQuestionnaireProps = {
	className?: string;
	description?: string;
	fieldValue: string;
	question: string;
	required: boolean;
	textLength?: TextLength;
} & Partial<ComponentPropsWithoutRef<typeof FormattedInput>>;

export const TextAreaQuestionnaire = ({
	className,
	description,
	question,
	textLength = TextLength.SHORT,
	required,
	fieldValue,
	...props
}: TextAreaQuestionnaireProps) => {
	const [, { error }] = useField(props.name);
	const characterLimit = rfxSubmission.helpers.getTextLengthValue(textLength);

	const subTitle = useMemo(() => {
		return `Maximum of ${characterLimit} characters.`;
	}, [characterLimit]);

	return (
		<div
			className={cn(className)}
			data-testid={`header-${props?.name}`}
		>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				description={description}
				error={error}
				touchedField={props?.touchedField}
			/>
			<div>
				{/* @ts-ignore */}
				<FormattedInput
					characterLimit={characterLimit}
					rfq
					className="my-4 w-full"
					required={required}
					placeholder="Enter your answer here..."
					subTitle={subTitle}
					// hideError
					{...props}
				/>
			</div>
		</div>
	);
};
